declare global {
    interface Window {
        lintrk?: (action: string, data?: { conversion_id: number | string }) => void;
    }
}

/** LinkedIn Insight Tag partner ID (must match index.html). */
export const LINKEDIN_PARTNER_ID = '1990828';

/**
 * Conversion ID for the "Meeting Booked" event in LinkedIn Campaign Manager.
 * Set REACT_APP_LINKEDIN_MEETING_BOOKED_CONVERSION_ID in Netlify build env.
 */
export const LINKEDIN_MEETING_BOOKED_CONVERSION_ID =
    process.env.REACT_APP_LINKEDIN_MEETING_BOOKED_CONVERSION_ID ?? '';

export function trackLinkedInConversion(conversionId: string | number): void
{
    if (typeof window === 'undefined' || conversionId === '' || conversionId == null)
    {
        return;
    }

    if (typeof window.lintrk !== 'function')
    {
        return;
    }

    window.lintrk('track', { conversion_id: conversionId });
}
